module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBold.aebf4fe1.ttf";